import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ModalSuccess from '../components/Modals/modalSuccess';
import ModalError from '../components/Modals/modalError';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const { createContext } = require('react');

const ModalContext = createContext({});

export default function ModalProvider({ children }) {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const navigate = useNavigate();
  const [modalProps, setModalProps] = useState({
    title: '',
    description: '',
    type: 'success',
    confirm: null,
    isRedirect: false,
  });

  const renderModal = () => {
    const config = {
      title: modalProps.title,
      description: modalProps.description,
      confirm: modalProps.confirm,
      isRedirect: modalProps.isRedirect,
      type: modalProps.type,
      isOpen: isOpenModal,
      handleClose: () => setIsOpenModal(false),
      redirect: () => {
        setIsOpenModal(false);
        navigate('/');
      },
    };

    if (modalProps.type === 'success') {
      return <ModalSuccess {...config} />;
    }

    return <ModalError {...config} />;
  };

  return (
    <ModalContext.Provider value={{ setIsOpenModal, setModalProps }}>
      {renderModal()}
      {children}
    </ModalContext.Provider>
  );
}

export function useModal() {
  return useContext(ModalContext);
}
